import { NgClass } from '@angular/common';
import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  OnInit,
  signal,
  viewChild,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { GalleryLayout3, GalleryLayout3Item } from '@components/gallery/components/gallery-layout-3/model';
import { DataLayerService } from '@services/data-layer';
import { ResponsiveService } from '@services/responsive';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';
import { VideoComponent } from '@shared/components/video';
import { AddClassOnViewDirective } from '@shared/directives';

@Component({
  selector: 'app-gallery-layout-3',
  imports: [
    RouterLink,
    AddClassOnViewDirective,
    ButtonComponent,
    VideoComponent,
    TitleComponent,
    NgClass,
    ImageComponent,
  ],
  templateUrl: './gallery-layout-3.component.html',
  styleUrl: './gallery-layout-3.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryLayout3Component implements OnInit {
  readonly data = input.required<GalleryLayout3>();
  readonly figure = viewChild.required<ElementRef<HTMLElement>>('figure');
  title = signal<Title>(null!);
  figureWidth = signal<string>(null!);
  isBackgroundWhite = signal<boolean>(null!);
  readonly breakpoints = inject(ResponsiveService).breakpoints;
  readonly #router = inject(Router);
  readonly #dataLayerService = inject(DataLayerService);

  constructor() {
    afterNextRender(() => {
      this.figureWidth.set(`${this.figure().nativeElement.clientWidth}px`);
    });
  }

  ngOnInit(): void {
    const data = this.data();
    this.isBackgroundWhite.set(!!data?.isBackgroundWhite);
    if (data.title) {
      this.title.set({
        level: 'H2',
        size: {
          mobile: 'H2',
          desktop: 'H2',
        },
        font: 'IVY_MODE',
        color: 'BLACK',
        align: {
          mobile: 'LEFT',
          desktop: 'LEFT',
        },
        text: data.title,
      });
    }
  }

  onClick(item: GalleryLayout3Item): void {
    if (item.video) return;
    void this.#router.navigateByUrl(item.url);
  }

  onButtonClick(button_text_value: string, context: string): void {
    this.#dataLayerService.logEvent({
      event_code: 'click_cta_webserie',
      button_text_value,
      context,
    });
  }

  onVideoComplete(context: string, id: string): void {
    if (sessionStorage.getItem('complete::' + id) === 'true') return;
    sessionStorage.setItem('complete::' + id, 'true');
    this.#dataLayerService.logEvent({
      event_code: 'video_complete_webserie',
      context,
    });
  }

  onVideoStart(context: string, id: string): void {
    if (sessionStorage.getItem('start::' + id) === 'true') return;
    sessionStorage.setItem('start::' + id, 'true');
    this.#dataLayerService.logEvent({
      event_code: 'video_start_webserie',
      context,
    });
  }
}
